import { Modal } from "react-bootstrap";
import { PlaylistCreateDTO } from "../../view/spotipitan/types";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";

interface CreatePlaylistModalProps {
    hash: string;
    onClose: () => void;
    onSave: (playlist: PlaylistCreateDTO) => void;
    loading?: boolean;
}

const CreatePlaylistModal: React.FC<CreatePlaylistModalProps> = ({ hash, onClose, onSave, loading }) => {

    const location = useLocation();
    const [openCreatePlaylist, setOpenCreatePlaylist] = useState(false);
    const [playlistName, setPlaylistName] = useState('');

    useEffect(() => {
        setOpenCreatePlaylist(location.hash === `#${hash}`);
    }, [hash, location]);


    const handleCreatePlaylist = () => {
        if (playlistName.trim() === '') {
            toast.error('El nombre de la playlist no puede estar vacío');
            return;
        }

        onSave({
            name: playlistName
        });
    }

    return (
        <Modal show={openCreatePlaylist} onClose={onClose}>
            <div className="modal-header">
                <h5 className="modal-title">Crear Playlist</h5>
                <button type="button" className="btn-close" onClick={() => onClose()}></button>
            </div>
            <div className="modal-body">
                <div className="form-floating mb-3">
                    <input autoFocus={openCreatePlaylist}
                        onChange={(e) => setPlaylistName(e.target.value)}
                        value={playlistName}
                        onKeyDown={(e) => e.key === 'Enter' && handleCreatePlaylist()}
                        type="text" className="form-control" id="playlistName" placeholder="Nombre de la playlist" />
                    <label htmlFor="playlistName">Nombre de la playlist</label>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => onClose()}>Cerrar</button>
                <button type="button" className="btn btn-primary" onClick={handleCreatePlaylist} disabled={loading}>Crear</button>
            </div>
        </Modal>
    );
};

export default CreatePlaylistModal;
